export default "__VITE_ASSET__BGcQeq9j__"